import { LeftOutlined } from '@ant-design/icons';

import { Flex } from '@/components/base';
import IconButton from '@/components/Button/IconButton';
import KeyboardNavigator from '@/components/KeyboardNavigator/KeyboardNavigator';
import type {
  KeyboardNavigatorKeymap,
  SelectedNavigatorItem,
} from '@/components/KeyboardNavigator/types';
import List from '@/components/List/List';
import Typo from '@/components/Typography/Typo';

import type { ExtendedFilterQueryFormatT } from './searchQueryBuilderTypes';
import SearchQueryBuilderStyles from './styles';

const { SelectListWrapperStyle, MatchedValueText, FilterValueText } =
  SearchQueryBuilderStyles;

type Props = {
  onBackClick: () => void;
  targetName: string;
  selectedItem: SelectedNavigatorItem | null;
  setSelectedItem: (item: SelectedNavigatorItem | null) => void;
  keymap: KeyboardNavigatorKeymap | null;
  debouncedInput: string;
  data: ExtendedFilterQueryFormatT[] | null;
  isLoading: boolean;
};

const AsyncSearchTargetView = (props: Props) => {
  const {
    targetName,
    selectedItem,
    setSelectedItem,
    keymap,
    debouncedInput,
    data,
    isLoading,
    onBackClick,
  } = props;

  if (keymap === null || keymap.length === 0) return null;
  return (
    <SelectListWrapperStyle>
      <KeyboardNavigator.List f={1}>
        <KeyboardNavigator.Item
          selected={selectedItem?.col === 0 && selectedItem.index === 0}
          onMouseEnter={() => {
            setSelectedItem({
              col: 0,
              index: 0,
            });
          }}
          onClick={() => keymap[0][0].action()}
        >
          <Flex a="center" g={8}>
            <IconButton
              icon={<LeftOutlined />}
              onClick={onBackClick}
              sizeType="m"
            />
            <Typo type="body3" className="text-gray-600">
              {targetName}&nbsp;&nbsp;
              <MatchedValueText
                text={debouncedInput}
                matchedValue={debouncedInput}
              />
              ...
            </Typo>
          </Flex>
        </KeyboardNavigator.Item>
        <List
          className="gap-0.5 flex-1 overflow-unset"
          data={data || []}
          isLoading={isLoading}
          render={(value, index) => {
            const offsetIndex = index + 1;
            return (
              <KeyboardNavigator.Item
                key={`${value.columnKey}.${value.filterValues[0].filterKey}`}
                selected={
                  selectedItem?.col === 0 && selectedItem.index === offsetIndex
                }
                onMouseEnter={() => {
                  setSelectedItem({
                    col: 0,
                    index: offsetIndex,
                  });
                }}
                onClick={() => keymap[0]?.[offsetIndex]?.action()}
              >
                <FilterValueText
                  matchedValue={debouncedInput}
                  filterQueryFormat={value}
                />
              </KeyboardNavigator.Item>
            );
          }}
        />
      </KeyboardNavigator.List>
    </SelectListWrapperStyle>
  );
};

export default AsyncSearchTargetView;
